import { User } from "firebase/auth";
import React, { useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { createProject } from "../../services/projectService";
import { Project } from "../../types/Project";
import "./CreateProjectForm.scss";

interface CreateProjectFormProps {
  fireUser: User;
  onSuccess?: (project: Project) => void;
}

const CreateProjectForm: React.FC<CreateProjectFormProps> = ({
  fireUser,
  onSuccess,
}) => {
  const navigate = useNavigate();

  const [projectName, setProjectName] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [isCreatingProject, setIsCreatingProject] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleCreateProject = async (e: React.FormEvent) => {
    e.preventDefault();

    setIsCreatingProject(true);
    try {
      const newProject = await createProject(
        fireUser.uid,
        projectName,
        projectDescription,
      );
      navigate(`/project/${newProject.id}`);
    } catch (error) {
      setError((error as Error).message);
    } finally {
      setIsCreatingProject(false);
    }
  };

  return (
    <div className="create-project-container">
      <div className="form-header">List a New Project</div>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleCreateProject}>
        <Form.Group className="mb-3" controlId="projectName">
          <Form.Label>Project Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter project name"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="projectDescription">
          <Form.Label>Project Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter project description"
            value={projectDescription}
            onChange={(e) => setProjectDescription(e.target.value)}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" disabled={isCreatingProject}>
          {isCreatingProject ? "Saving..." : "List Project"}
        </Button>
      </Form>
    </div>
  );
};

export default CreateProjectForm;
